import { api } from './api';

function urlBase64ToUint8Array(b64: string): Uint8Array {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const s = (b64 + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(s);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function subscribeToPush(): Promise<boolean> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  const reg = await navigator.serviceWorker.ready;
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return false;
  const existing = await reg.pushManager.getSubscription();
  if (existing) {
    const j = existing.toJSON() as any;
    if (j.endpoint && j.keys?.p256dh && j.keys?.auth) {
      await api.pushSubscribe(j.endpoint, { p256dh: j.keys.p256dh, auth: j.keys.auth });
      return true;
    }
    await existing.unsubscribe();
  }
  const { key } = await api.pushPublicKey();
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(key).buffer as ArrayBuffer,
  });
  const j = sub.toJSON() as any;
  await api.pushSubscribe(j.endpoint, { p256dh: j.keys.p256dh, auth: j.keys.auth });
  return true;
}

export async function unsubscribeFromPush(): Promise<boolean> {
  if (!('serviceWorker' in navigator)) return false;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return true;
  const j = sub.toJSON() as any;
  await sub.unsubscribe();
  if (j.endpoint) await api.pushUnsubscribe(j.endpoint).catch(() => {});
  return true;
}
